// DEPENDENCIES //
import React, { useState, useEffect } from "react";

// IMAGES //
import slideshow_tjs_01 from "../../assets/slideshow_tjs_01.png";
import slideshow_tjs_02 from "../../assets/slideshow_tjs_02.png";
import slideshow_tjs_03 from "../../assets/slideshow_tjs_03.png";
import slideshow_tjs_04 from "../../assets/slideshow_tjs_04.png";
import slideshow_tjs_05 from "../../assets/slideshow_tjs_05.png";
import slideshow_tjs_06 from "../../assets/slideshow_tjs_06.png";
import slideshow_tjs_07 from "../../assets/slideshow_tjs_07.jpg";

// STYLES //
import "./slideshowTJs.css"

// HELPER FUNCTIONS //
function shuffle(array) {
  const copy = [...array];

  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));

    [copy[i], copy[j]] = [copy[j], copy[i]];
  }

  return copy;
}

function SlideshowTJs() {
  const [images] = useState(() =>
    shuffle([
      slideshow_tjs_01,
      slideshow_tjs_02,
      slideshow_tjs_03,
      slideshow_tjs_04,
      slideshow_tjs_05,
      slideshow_tjs_06,
      slideshow_tjs_07,
    ])
  );

  // const [currentSlide, setCurrentSlide] = useState(0);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [previousSlide, setPreviousSlide] = useState(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setPreviousSlide(currentSlide);
      setCurrentSlide((currentSlide + 1) % images.length);
    }, 2000);

    return () => clearInterval(interval);
  }, [currentSlide, images.length]);

  return (
    <div className="slideshow-tjs-container">
      <div className="slideshow-tjs">
        {previousSlide !== null && (
          <img
            className="slideshow-tjs-image previous-slide-tjs"
            src={images[previousSlide]}
            alt=""
          />
        )}

        <img
          key={currentSlide}
          className="slideshow-tjs-image current-slide-tjs"
          src={images[currentSlide]}
          alt={`Slide ${currentSlide + 1}`}
        />
      </div>
    </div>
  );
}

export default SlideshowTJs;

